import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Dialog, VerticalRhythm } from 'mage-components';
import { translator, Message } from 'mage-i18n';
import { AlertBannerWarning, Frame, Typography, SpacerVertical } from '@klarna/bubble-ui';

import DownloadLocalDataLink from '../DownloadLocalDataLink';

const tPrefix = 'products-fe.components.api_key_dialog';

const ApiKeyDialog = ({ t, apiKey, onClose, onDownload, merchantId }) => (
  <Dialog onClose={onClose}>
    <Typography textToken="text-style/headings/blocks/bold/tertiary">
      {t(`${tPrefix}.title`)}
    </Typography>
    <VerticalRhythm spacing={4} />
    <AlertBannerWarning content={t(`${tPrefix}.subtitle`)} />
    <VerticalRhythm spacing={6} />
    <Frame
      cornerRadiusToken="corner-radius/none"
      backgroundColorToken="colors/backgrounds/subtle-inline"
    >
      <Typography textToken="text-style/text/paragraphs/tall/bold" align="center">
        {t(`${tPrefix}.key_box.username.label`)}
      </Typography>
      <SpacerVertical spaceToken="space/100" />
      <Typography align="center" textToken="text-style/text/super-paragraphs/tall/regular">
        {apiKey.username}
      </Typography>
    </Frame>
    <Frame
      cornerRadiusToken="corner-radius/none"
      backgroundColorToken="colors/backgrounds/subtle-inline"
    >
      <Typography textToken="text-style/text/paragraphs/tall/bold" align="center">
        {t(`${tPrefix}.key_box.password.label`)}
      </Typography>
      <SpacerVertical spaceToken="space/100" />
      <Typography align="center" textToken="text-style/text/super-paragraphs/tall/regular">
        {apiKey.password}
      </Typography>
    </Frame>
    <VerticalRhythm spacing={6} />
    {apiKey && apiKey.username ? (
      <DownloadLocalDataLink
        data={[
          `Klarna API username: ${apiKey.username}`,
          `Klarna API password: ${apiKey.password}`,
        ].join('\r\n')}
        filename={t(`${tPrefix}.key_box.file_name`) + `_${merchantId}.txt`}
      >
        <Message path={`${tPrefix}.buttons.download`} />
      </DownloadLocalDataLink>
    ) : null}
  </Dialog>
);

ApiKeyDialog.propTypes = {
  apiKey: PropTypes.object.isRequired,
  merchantId: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
};

export default connect(state => ({
  t: translator(state),
}))(ApiKeyDialog);
